let history = []; // 撤销操作
let canvasElm = document.querySelector('.style-canvas');
$(document).ready(function() {
  // 第一次进来加载初始化数据
  if($('#personaliza-product-default-selected-variant').val() == 'false') {
    // 默认选择的产品如果没有库存的话，那就显示正常的按钮
    $('.normal--buy-buttons-block').css('display', 'grid');
    $('.personaliza-button-block').hide();
  }

  $('#type-variant-picker input[type="radio"]').change(function() {
    // 切换型号也要有对应的变化
    var selectedType = $(this).val();
    selectedType = selectedType.toLowerCase();
    selectedType = selectedType.replace(/\s+/g, '');
    // console.log(selectedType);
    // 获取当前变体是否可用
    console.log($('#personalize-option-type-' + selectedType).attr('available'));
    var available = $('#personalize-option-type-' + selectedType).attr('available');
    if(available != 'false') {
      // 需要显示可定制按钮
      $('.normal--buy-buttons-block').hide();
      $('.personaliza-button-block').show();
    } else {
        $('.normal--buy-buttons-block').css('display', 'grid');
        $('.personaliza-button-block').hide();
    }

    // 重置被选中的效果
    $('.step-cancel-button').trigger('click');
  })

  $('#personaliza-button').click(function() {
    // 根据选择的颜色显示图片
    $('.select-style-flex').each(function() {
      $(this).removeClass('select-style-color-selected');
      $(this).addClass('select-style-color-hidden');
    });
    var optionsId = 'option';
    // 拼接型号
    var selectedType = $('#type-variant-picker input[type="radio"]:checked').val();
    selectedType = selectedType.toLowerCase();
    selectedType = selectedType.replace(/\s+/g, '');
    optionsId +=  selectedType
    
    $('#' + optionsId).removeClass('select-style-color-hidden');
    $('#' + optionsId).addClass('select-style-color-selected');
    var hasSelected = false;
    $('#' + optionsId + ' .style-block').each(function() {
      if($(this).hasClass('style-img-selected')) {
        hasSelected = true;
      }
    });
    if(!hasSelected) {
      $('#' + optionsId + ' .style-block').each(function() {
        if($(this).hasClass('style-img-hidden')) {
          $(this).removeClass('style-img-hidden');
          $(this).find('.select-button').css('display', 'block');
        }
      });
    }
    $('.overlay').show();
    $('.personaliza-dialog-content').show();
    // 把粘在顶部的header给隐藏一下
    // $('#shopify-section-sections--17863612727551__header').css('position', 'static');
    $('.shopify-section--header').css('position', 'static');
    // 初始化画布 因为要暂时去掉二选一的功能，所以一进来就直接初始化画布吧
    canvasElm = document.querySelector('#' + optionsId + ' .style-img-selected .style-canvas');
    resizeObserver.observe(canvasElm);
  });

  $('.personaliza-header .close-button').click(function() {
    $('.overlay').hide();
    $('.personaliza-dialog-content').hide();
    // 把粘在顶部的header开放出来
    // $('#shopify-section-sections--17863612727551__header').css('position', 'sticky');
    $('.shopify-section--header').css('position', 'sticky');
  });
  
  $('.personaliza-dialog .overlay').click(function() {
    // 如果定制了就要确认才能关闭
    // var personalizaLink = $('#personalizaLink').val().trim();
    // var isPreviewConfirm = $('#isPreviewConfirm').val();
    // console.log('isPreviewConfirm:', isPreviewConfirm);
    // if((personalizaLink !== '' || personalizaLink)) {}
    $('.overlay').hide();
    $('.personaliza-dialog-content').hide();
    // $('#shopify-section-sections--17863612727551__header').css('position', 'sticky');
    $('.shopify-section--header').css('position', 'sticky');
  });

  $('.step-cancel-button').click(function() {
    // 全部重置
    var personalizaStep = $(this).closest('.personaliza-step');
    var personalizaContent = personalizaStep.prev('.personaliza-content');
    $(personalizaContent).find('.select-style-flex').each(function() {
      if(!$(this).hasClass('select-style-color-hidden')) {
        // 先移除掉需要拖拽的元素
        $(this).find('.style-img-selected').find('.personaliza-icon-img-instance').filter(function() {
          return true;
        }).remove();
        
      }
    });
    // 把个人定制的文本框给清空并且禁用掉
    personalizaStep.find('.personaliza-input').val('');
    // $('input[name="personalizaInput"]').prop('disabled', true); // 暂时先去除禁止输入的代码，之后上了产品样式二选一后再开放
    // 把历史记录给删掉
    history = [];
  });

  // 确认图片
  $('.preview-confirm').click(function() {
    // 图片已确认
    $('#isPreviewConfirm').val(true);
    // 关闭弹窗
    $('.personaliza-dialog-content').css('display', 'none');
    $('.overlay').css('display', 'none');
    $('.personaliza-button-block').css('display', 'none');
    $('.shopify-section--header').css('position', 'sticky');
    $('.normal--buy-buttons-block').css('display', 'grid');
  });
  // 返回重新保存
  $('.preview-back').click(function() {
    $('.personaliza-dialog-before').css('display', 'block');
    $('.personaliza-dialog-after').css('display', 'none');
    $('#isPreviewConfirm').val(false);
  });

  var stepSwiper = new Swiper(".stepSwiper", {
    slidesPerView: 1,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    allowTouchMove: true,
    on: {
      slideChange: function() {
        // console.log(this.slides);
        var slides = this.slides;
        var maxHeight = slides[0].offsetHeight;
        // 将所有slides设置成相同的高度
        for(var i = 0; i < slides.length; i++) {
          slides[i].style.height = maxHeight + 'px';
        }
      }
    },
  });


  const COMP_WIDTH = 80;
  const COMP_HEIGHT = 60;
  const SNAP_RANGE = 20;
  const LEFT_ALIGN_DISTANCE = 100;
  const compList = [];
  let n = 1;
  class Comp {
    constructor({ left = 0, right = 0, top = 0, bottom = 0, width = 'auto', height = 'auto', src = '', selected = false, parent = body, isText = false, isInit = false, transform = {} }) {
      if(isInit) {
        this.left = left;
        this.top = top
      } else {
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
      }
      this.width = width;
      this.height = height;
      this.selected = selected;
      this.src = src;
      this.isText = isText
      if(isText) {
        if(document.getElementById('personaliza-text-content')) {
          var existElement = document.getElementById('personaliza-text-content');
          // element.setAttribute('src', src);
          existElement.parentNode.removeChild(existElement);
        }
        if (src != '') {
          var element = document.createElement('img');
          element.classList.add('personaliza-icon-img-instance');
          element.classList.add('personaliza-icon-init-size');
          element.id = 'personaliza-text-content';
          if(!history.includes(element.id)) {
            history.push(element.id);
          }
          element.setAttribute('src', src);
        }
      }else {
        var element = document.createElement('img');
        element.classList.add('personaliza-icon-img-instance');
        element.classList.add('personaliza-icon-init-size');
        element.id = 'personaliza-icon-content-' + n;
        n++;
        history.push(element.id);
        element.setAttribute('src', src);
      }
      // console.log('element: ', element);
      // if(element === undefined) {
      //   return false;
      // }
      if(width != 'auto') {
        element.style.width = `${width}px`;``
      }
      if(height != 'auto') {
        element.style.height = `${height}px`;
      }
      if(isInit) {
        element.style.left = left + 'px';
        element.style.top = top + 'px';
        if(Object.keys(transform).length === 0) {
          console.log('inner transform: ', 2515151512);
          element.style.transform = '';
        }else {
          console.log('inner transform: ', transform);
          element.style.transform = 'translate(' + transform.translateX + 'px, ' + transform.translateY + 'px)';
        }
      }else {
        element.style.left = `${left}px`;
        element.style.top = `${top}px`;
        element.style.transform = '';
      }
      if (this.selected) {
        element.classList.add('comp-selected');
      }
      this.element = element;
      this.parent = parent;
      this.parent.appendChild(this.element);
    }
    updateState() {
      const { left, top, width, height } = this.element.style;
      this.element.style.transform = '';
      const src = this.element.getAttribute('src');
      this.src = src;
      this.left = parseFloat(left);
      this.top = parseFloat(top);
      this.right = parseFloat(left) + parseFloat(width);
      this.bottom = parseFloat(top) + parseFloat(height);
      this.width = width;
      this.height = height;
    }
    toggleSelect(selected) {
      this.element.style.transform = '';
      this.selected = selected;
      if (selected) {
        this.element.classList.add('comp-selected');
        this.element.style.opacity = 0.8;
      } else {
        this.element.classList.remove('comp-selected');
        this.element.style.opacity = 1;
      }
    }
  }

  const resizeObserver = new ResizeObserver((entries) => {
    for (let i = 0; i < compList.length; i++) {
      const comp = compList[i];
      interact(comp.element).reflow({ name: 'drag', axis: 'xy' }).then(() => {
        comp.updateState();
      });
    }
  });
  
  $('.select-button button').click(function() {
    $(this).parent().parent().addClass('style-img-selected');
    $('.style-block').each(function(){
      if(!$(this).hasClass('style-img-selected')) {
        $(this).addClass('style-img-hidden');
      }
    });
    // $(this).parent().css('display', 'none');
    $('.select-button').css('display', 'none');
    // 选择样式后input框就可以给输入
    $('input[name="personalizaInput"]').prop('disabled', false);
    canvasElm = document.querySelector('.style-img-selected .style-canvas');
    resizeObserver.observe(canvasElm);
  });

  $('.img-preview-block').click(function() {
    // 上传图片预览
    // 如果产品是黑色或者灰色就显示白色的icon，如果是其他颜色就显示黑色的icon
    var selectedValue = $('#color-variant-picker input[type="radio"]:checked').val();
    selectedValue = selectedValue.replace(/\s+/g, '');
    if($('#' + selectedValue).find('.style-img-selected').length == 0) {
      // 前面没有选中颜色样式的话就不能触发
      return false;
    }
    // console.log(selectedValue);
    var src = $(this).children().first().attr('src');

    var currentImgWidth = $(this).width();
    var currentImgHeight = $(this).height();
    var position = calculatePositioning(currentImgWidth, currentImgHeight);
    createDragOrResizeElement(src, false, position);
  });
  $('.personaliza-icon-img').click(function(){
    var optionsId = 'option';
    // 拼接型号
    var selectedType = $('#type-variant-picker input[type="radio"]:checked').val();
    selectedType = selectedType.toLowerCase();
    selectedType = selectedType.replace(/\s+/g, '');
    optionsId +=  selectedType
    if($('#' + optionsId).find('.style-img-selected').length == 0) {
      // 前面没有选中颜色样式的话就不能触发
      return false;
    }
    // 当前变体是什么颜色
    var selectedValue = $('#' + optionsId).attr('color');
    var src = ''
    if(selectedValue == 'black' || selectedValue == 'grey' || selectedValue.includes('black') || selectedValue.includes('grey')) {
      src = $(this).data('white');
    }else {
      src = $(this).data('black');
    }

    var currentImgWidth = $(this).width();
    var currentImgHeight = $(this).height();
    console.log('current:', currentImgWidth, currentImgHeight);

    var position = calculatePositioning(currentImgWidth, currentImgHeight);
    createDragOrResizeElement(src, false, position);
    if($('#undo-button').is(':hidden')) {
      $('#undo-button').show();
    }
  });

  $('.personaliza-input').keyup(function() {
    console.log($(this).val());
    // 获取显示文本的颜色
    // var selectedValue = $('#color-variant-picker input[type="radio"]:checked').val();
    // selectedValue = selectedValue.replace(/\s+/g, '');
    var optionsId = 'option';
    // 拼接型号
    var selectedType = $('#type-variant-picker input[type="radio"]:checked').val();
    selectedType = selectedType.toLowerCase();
    selectedType = selectedType.replace(/\s+/g, '');
    optionsId +=  selectedType

    if($('#' + optionsId).find('.style-img-selected').length == 0) {
      // 前面没有选中颜色样式的话就不能触发
      return false;
    }
    // 当前变体是什么颜色
    var selectedValue = $('#' + optionsId).attr('color');
    var src = '';
    if ($(this).val().length != 0) {
      if(selectedValue == 'black' || selectedValue == 'grey' || selectedValue.includes('black') || selectedValue.includes('grey')) {
        src = redrawCanvas($(this).val(), 'white');
      }else {
        src = redrawCanvas($(this).val(), 'black');
      }
    }else {
      // 直接移除掉当前元素
      $('#personaliza-text-content').remove();
      let textIndex = history.findIndex(item => item === 'personaliza-text-content');
      if (textIndex !== -1) {
        history.splice(textIndex, 1);
      }
    }
    var currentImgWidth = 90;
    var currentImgHeight = 46;
    var position = calculatePositioning(currentImgWidth, currentImgHeight);
    // if(!$(this).val().length != 0) {
    //   // 填写了文本之后才调用添加图片
    //   createDragOrResizeElement(src, true, position);
    // }
    createDragOrResizeElement(src, true, position);
    // 是否显示撤销按钮
    if($('#undo-button').is(':hidden')) {
      $('#undo-button').show();
    }
  });

  // 通过原始图片的宽高来确定定位
  function calculatePositioning(originalWidth, originalHeight) {
    var maxWidth = 86 * 1.1;
    var maxHeight = 60 * 1.1;
    // 计算自适应宽度和高度
    var aspectRatio = originalWidth / originalHeight;
    var adaptedWidth, adaptedHeight;
    // 根据最大宽度和宽高比计算自适应高度
    adaptedWidth = maxWidth;
    adaptedHeight = Math.round(maxWidth / aspectRatio);
    // 如果自适应高度超过了最大高度，重新计算宽度和高度
    if (adaptedHeight > maxHeight) {
        adaptedHeight = maxHeight;
        adaptedWidth = Math.round(adaptedHeight * aspectRatio);
    }
    console.log('adaptedWidth: ', adaptedWidth);
    console.log('adaptedHeight', adaptedHeight);

    var optionsId = 'option';
    // 拼接型号
    var selectedType = $('#type-variant-picker input[type="radio"]:checked').val();
    selectedType = selectedType.toLowerCase();
    selectedType = selectedType.replace(/\s+/g, '');
    optionsId +=  selectedType

    // var parentElem = $('.select-style-flex:not(.select-style-color-hidden) .style-img-selected').find('.style-canvas');
    var parentElem = $('#' + optionsId).find('.style-img-selected').find('.style-canvas'); // 父元素是放大了1.1倍的，所以宽和高要乘1.1
    console.log(parentElem.hasClass('style-1'));
    console.log(parentElem.hasClass('style-2'));
    var parentWidth = parseFloat((parseFloat(parentElem.width()) * 1.1).toFixed(2));
    var parentHeight = parseFloat((parseFloat(parentElem.height()) * 1.1).toFixed(2));
    console.log('parentWidth: ', parentWidth);
    console.log('parentHeight: ', parentHeight);
    var leftPos = (parentWidth * 50) / 100;
    // 不同样式应该是在不同的定位
    if (parentElem.hasClass('style-1')) {
      var topPos = (parentHeight * 73) / 100;
    }
    if(parentElem.hasClass('style-2')) {
      var topPos = (parentHeight * 58) / 100;
    }
    var translateX = (adaptedWidth / 2);
    var translateY = (adaptedHeight / 2);
    console.log('left: ', leftPos);
    console.log('top: ', topPos);
    
    var position = {
      left: leftPos,
      top: topPos,
      translateX: -(translateX),
      translateY: -(translateY)
    };
    console.log('position: ', position);
    return position;
  }

  function createDragOrResizeElement(content, isText = false, position = {}) {
    // console.log(canvasElm)
    if (Object.keys(position).length === 0) {
      var comp = new Comp({ left: 0, right: 0, top: 0, bottom: 0, width: 'auto', height: 'auto', src: content, selected: false, parent: canvasElm, isText: isText, isInit: true, transform: {} });
    } else {
      var transform = {
        translateX: position.translateX,
        translateY: position.translateY
      };
      var comp = new Comp({ left: position.left, right: 0, top: position.top, bottom: 0, width: 'auto', height: 'auto', src: content, selected: false, parent: canvasElm, isText: isText, isInit: true, transform: transform });
    }
    initCompDraggable(comp);
    initCompResizable(comp);
  }

  function dragTemplateStart(event) {
    const interaction = event.interaction;

    if (interaction.pointerIsDown && !interaction.interacting()) {
      const template = event.target;
      console.log(template);
      const templateRect = template.getBoundingClientRect();
      const canvasRect = canvasElm.getBoundingClientRect();
      const left = templateRect.left - canvasRect.left;
      const right = templateRect.right - canvasRect.left;
      const top = templateRect.top - canvasRect.top;
      const bottom = templateRect.bottom - canvasRect.top;
      const src = template.getAttribute('src');
      const targetId = template.id;
      if(targetId == 'personaliza-text-content') {
        const comp = new Comp({ left, right, top, bottom, width: 'auto', height: 'auto', src, selected: false, parent: canvasElm, isText: true });
        compList.push(comp);
      }else {
        const comp = new Comp({ left, right, top, bottom, width: 'auto', height: 'auto', src, selected: false, parent: canvasElm, isText: false });
        compList.push(comp);
      }
      interaction.start({ name: 'drag' }, event.interactable, comp.element);
    }
  }

  function dragMove(event) {
    const target = event.target;
    const x = (parseFloat(target.style.left)) + event.dx;
    const y = (parseFloat(target.style.top)) + event.dy;
    target.style.left = `${x}px`;
    target.style.top = `${y}px`;
    // update state if instance
    const comp = compList.find(c => c.element === target);
    if (comp) {
      comp.updateState();
    }
  }

  function dragTemplateEnd(event) {
    const element = event.target;
    const elementRect = element.getBoundingClientRect();
    const canvasRect = canvasElm.getBoundingClientRect();
    const comp = compList.find(c => c.element === element);
    if (!comp) {
      element.remove();
    }
    // if element in canvas entirely
    if (
        elementRect.left > canvasRect.left &&
        elementRect.right < canvasRect.right &&
        elementRect.top > canvasRect.top &&
        elementRect.bottom < canvasRect.bottom
    ) {
      // convert to comp-instance, avoid canvas UI response
      // comp.convertToInstance();
      initCompDraggable(comp);
      initCompResizable(comp);
    } else {
      compList.splice(compList.indexOf(comp), 1);
      element.remove();
    }
    dragOrResizeEnd(event);
  }

  function initCompDraggable(comp) {
    interact(comp.element).draggable({
      enabled: true,
      dragLockToAxis: true,
      tolerance: 2,
      restrict: {
        drag: 'self',
        endOnly: false,
      },
      modifiers: [
        // snap to other components
        interact.modifiers.snap({
            targets: [getSnapTarget],
            range: SNAP_RANGE,
            offset: 'parent',
            relativePoints: [
                { x: 0, y: 0 },
                { x: 0, y: 1 },
                { x: 1, y: 0 },
                { x: 1, y: 1 },
            ],
        }),
        // restrict in canvas
        interact.modifiers.restrictRect({
            restriction: canvasElm,
        }),
      ],
      onstart: dragOrResizeStart,
      onmove: dragMove,
      onend: dragOrResizeEnd,
    });
  }

  const auxLineLeftElm = document.querySelector('.aux-line-left');
  function getSnapTarget(x, y, interaction) {
    const activeComp = compList.find(c => c.element === interaction.element);
    let leftNearestDistance = Number.POSITIVE_INFINITY;
    let leftNearestSnap;
    let xNearestDistance = Number.POSITIVE_INFINITY;
    let xNearestSnap;
    let yNearestDistance = Number.POSITIVE_INFINITY;
    let yNearestSnap;
    // if rezising, consider resize direction, in case that already snapped in opposite direction
    // if dragging, omit these conditions
    const { left: leftResizeOrDrag = true, right: rightResizeOrDrag = true, top: topResizeOrDrag = true, bottom: bottomResizeOrDrag = true } = interaction.edges ?? {};

    // iterate other components, find nearest snap coordinates
    for (let i = 0; i < compList.length; i++) {
      if (activeComp === compList[i]) continue;
      const otherComp = compList[i];
      // left align, consider as left sides' snap
      if (activeComp.left <= otherComp.left + LEFT_ALIGN_DISTANCE && activeComp.left >= otherComp.left - LEFT_ALIGN_DISTANCE && leftResizeOrDrag) {
        const leftDis = Math.abs(activeComp.left - otherComp.left);
        if (leftDis < leftNearestDistance) {
          leftNearestDistance = leftDis;
          leftNearestSnap = otherComp.left;
        }
      }
      // left and right snap, two components must have overlapping y coords
      if (activeComp.top < otherComp.bottom && activeComp.bottom > otherComp.top) {
        // snap from right to left
        if (activeComp.left >= otherComp.right - SNAP_RANGE && leftResizeOrDrag) {
          const xDis = activeComp.left - otherComp.right;
          if (xDis < xNearestDistance) {
            xNearestDistance = xDis;
            xNearestSnap = otherComp.right;
          }
        }
        // snap from left to right
        if (activeComp.right <= otherComp.left + SNAP_RANGE && rightResizeOrDrag) {
          const xDis = otherComp.left - activeComp.right;
          if (xDis < xNearestDistance) {
            xNearestDistance = xDis;
            xNearestSnap = otherComp.left;
          }
        }
      }
      // top and bottom snap, two components must have overlapping x coords
      if (activeComp.left < otherComp.right && activeComp.right > otherComp.left) {
        // snap from bottom to top
        if (activeComp.top >= otherComp.bottom - SNAP_RANGE && topResizeOrDrag) {
          const yDis = activeComp.top - otherComp.bottom;
          if (yDis < yNearestDistance) {
            yNearestDistance = yDis;
            yNearestSnap = otherComp.bottom;
          }
        }
        // snap from top to bottom
        if (activeComp.bottom <= otherComp.top + SNAP_RANGE && bottomResizeOrDrag) {
          const yDis = otherComp.top - activeComp.bottom;
          if (yDis < yNearestDistance) {
              yNearestDistance = yDis;
              yNearestSnap = otherComp.top;
          }
        }
      }
    }
    // handle aux-line-left
    if (leftNearestSnap) {
      auxLineLeftElm.style.opacity = '1';
      auxLineLeftElm.style.transform = `translate(${leftNearestSnap}px, 0)`;
    } else {
      auxLineLeftElm.style.opacity = '0';
    }
    // handle left align and left/right snap
    if (leftNearestDistance < xNearestDistance) {
      xNearestDistance = leftNearestDistance;
      xNearestSnap = leftNearestSnap;
    }
    // find nearest distance
    const nearestDistance = Math.min(xNearestDistance, yNearestDistance);
    // if resize corner, return point snap, otherwise return axis snap
    let result;
    if (xNearestDistance <= SNAP_RANGE && yNearestDistance <= SNAP_RANGE && (leftResizeOrDrag || rightResizeOrDrag) && (topResizeOrDrag || bottomResizeOrDrag)) {
      result = { x: xNearestSnap, y: yNearestSnap, range: Math.sqrt(2 * SNAP_RANGE * SNAP_RANGE) };
    } else if (nearestDistance === xNearestDistance && (leftResizeOrDrag || rightResizeOrDrag)) {
      result = { x: xNearestSnap };
    } else if (nearestDistance === yNearestDistance && (topResizeOrDrag || bottomResizeOrDrag)) {
      result = { y: yNearestSnap };
    }
    return result;
  }

  function dragOrResizeStart(event) {
    const target = event.target;
    const comp = compList.find(c => c.element === target);
    if (comp) {
      comp.toggleSelect(true);
    }
  }

  function dragOrResizeEnd(event) {
    const target = event.target;
    const comp = compList.find(c => c.element === target);
    if (comp) {
      comp.toggleSelect(false);
    }
    auxLineLeftElm.style.opacity = '0';
  }

  function initCompResizable(comp) {
    interact(comp.element).resizable({
      enabled: true,
      edges: { left: true, right: true, top: true, bottom: true },
      tolerance: 0,
      modifiers: [
        // snap to other components
        interact.modifiers.snapEdges({
          targets: [getSnapTarget],
          range: SNAP_RANGE,
          offset: 'parent',
          relativePoints: [
              { x: 0, y: 0 },
              { x: 0, y: 1 },
              { x: 1, y: 0 },
              { x: 1, y: 1 },
          ],
        }),
        // restrict min size
        // interact.modifiers.restrictSize({
        //   min: { width: COMP_WIDTH, height: COMP_HEIGHT },
        // }),
        // restrict in canvas
        interact.modifiers.restrictEdges({
          outer: canvasElm,
        }),
      ],
      onstart: dragOrResizeStart,
      onmove: resizeMove,
      onend: dragOrResizeEnd,
    });
  }

  function resizeMove(event) {
    const target = event.target;
    const rx = event.deltaRect.left;
    const ry = event.deltaRect.top;
    target.style.width = `${event.rect.width}px`;
    target.style.height = `${event.rect.height}px`;
    target.style.maxWidth = event.rect.width + 10 + 'px';
    target.style.maxHeight = event.rect.height + 10 + 'px';
    target.style.left = `${parseFloat(target.style.left) + rx}px`;
    target.style.top = `${parseFloat(target.style.top) + ry}px`;
    const comp = compList.find(c => c.element === target);
    if (comp) {
        comp.updateState();
    }
  }

    function redrawCanvas(text, color) {
      var canvas = document.createElement('canvas');
      var ctx = canvas.getContext('2d');
      canvas.width = 110;
      canvas.height = 46;
      // 清除画布
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      // 设置文本样式等
      ctx.font = '15px Futura, Arial, sans-serif';
      ctx.fillStyle = color;
      ctx.textAlign = 'center';
      // 绘制文本
      ctx.fillText(text, canvas.width / 2, canvas.height / 2);
      // 生成的图片返回
      return canvas.toDataURL('image/png');
    }

  

  $('#undo-button').click(function() {
    console.log(history);
    if(history.length <= 0) {
      return false;
    }
    // 直接取出数组最后一个值，删除那个元素
    let lastElementId = history.pop();
    $('#' + lastElementId).remove();
    if(history.length <= 0) {
      $('#undo-button').hide();
    }
    if(!history.includes('personaliza-text-content')) {
      // 清空文本框
      $('input[name="personalizaInput"]').val('');
    }
  });

})

$(window).on('load', function() {
    $('.per-lazyload').each(function() {
        var $img = $(this);
        $img.attr('src', $img.data('src'));
        $img.removeClass('per-lazyload');
    });
});

